import { Component, EventEmitter, Output, OnDestroy } from '@angular/core';
import { DashboardHeaderComponent } from '../dashboard-header/dashboard-header.component';
import { DashboardService } from '../../dashboard.service';
import { DashboardSidebarComponent } from '../dashboard-sidebar/dashboard-sidebar.component';
import { DashboardWrapperService } from './dashboard-wrapper.service';
import { CommonService } from 'app/services/common.service';

@Component({
    selector: 'app-dashboard-wrapper',
    standalone: true,
    imports: [DashboardHeaderComponent, DashboardSidebarComponent],
    templateUrl: './dashboard-wrapper.component.html',
    styleUrl: './dashboard-wrapper.component.scss',
})
export class DashboardWrapperComponent {
    isOpen = false;
    selectedLanguage: any;
    haveUnreadNotifications: boolean = false;

    constructor(
        private _dashboardService: DashboardService,
        private _wrapperService: DashboardWrapperService,
        private _commonService: CommonService
    ) {}

    ngOnInit() {
        this._dashboardService.language$.subscribe((lang) => {
            this.selectedLanguage = lang;
        });
        this.fetchNotificationCount();
        this._commonService.refresh$.subscribe(() => {
            this.fetchNotificationCount();
        });
    }

    fetchNotificationCount() {
        this._wrapperService.getNotificationsCount().subscribe({
            next: (data) => {
                if (data?.unReadCount && data?.unReadCount > 0) {
                    this.haveUnreadNotifications = true;
                } else {
                    this.haveUnreadNotifications = false;
                }
            },
        });
    }

    toggleSidebar() {
        this.isOpen = !this.isOpen;
    }
}
